module.exports = __webpack_public_path__ + "gaming-logo-0ebac82f4abef7445289.png";